<template>
  <van-tabbar
      v-model="tabbarActive"
      placeholder
      fixed
      route
      active-color="#ff9f00"
      inactive-color="#8e8e93"
      class="modern-tabbar"
  >
    <van-tabbar-item to="/">
      <span>Home</span>
      <template #icon="props">
        <img :src="props.active ? homeIcon.active : homeIcon.inactive" class="tab-icon"/>
      </template>
    </van-tabbar-item>

    <van-tabbar-item to="/order">
      <span>Orders</span>
      <template #icon="props">
        <img :src="props.active ? orderIcon.active : orderIcon.inactive" class="tab-icon"/>
      </template>
    </van-tabbar-item>

    <van-tabbar-item to="/teams">
      <span>Invite</span>
      <template #icon="props">
        <img :src="props.active ? teamIcon.active : teamIcon.inactive" class="tab-icon"/>
      </template>
    </van-tabbar-item>

    <van-tabbar-item to="/user">
      <span>Profile</span>
      <template #icon="props">
        <img :src="props.active ? userIcon.active : userIcon.inactive" class="tab-icon"/>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import homeActive from '../assets/home_select.png'
import homeInactive from '../assets/home.png'
import orderActive from '../assets/order_select.png'
import orderInactive from '../assets/order.png'
import teamActive from '../assets/team_select.png'
import teamInactive from '../assets/team.png'
import userActive from '../assets/user_select.png'
import userInactive from '../assets/user.png'

const route = useRoute()

const homeIcon = { active: homeActive, inactive: homeInactive }
const orderIcon = { active: orderActive, inactive: orderInactive }
const teamIcon = { active: teamActive, inactive: teamInactive }
const userIcon = { active: userActive, inactive: userInactive }

// 根据当前路由自动设置激活状态
const tabbarActive = computed(() => {
  const path = route.path
  if (path === '/') return 0
  if (path === '/order') return 1
  if (path === '/teams') return 2
  if (path === '/user') return 3
  if (path === '/contact-task' || path.startsWith('/contact-task')) return 0 // contact-task 显示 Home 为激活状态
  return 0
})
</script>

<style scoped>
.modern-tabbar {
  height: 80px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  box-shadow: 0 -8px 25px rgba(0, 0, 0, 0.08);
  border-top: none;
  padding-bottom: env(safe-area-inset-bottom);
}

.tab-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

:deep(.van-tabbar-item--active) .tab-icon {
  transform: translateY(-4px);
}

:deep(.van-tabbar-item__text) {
  font-size: 11px;
  font-weight: 700;
  margin-top: 4px;
}
</style>
